import productType from "../../actions/product/productType";

const initialState = {
  product: null,
  loading: false,
  error: false,
  errorMessage: "",
  pageCounter: 1,
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case productType.START_FETCHING_PRODUCT:
      return {
        ...state,
        product: null,
        loading: true,
        error: false,
        pageCounter: 1,
      };
    case productType.SUCCESS_FETCHIED_PRODUCT:
      return {
        ...state,
        loading: false,
        product: action.payload,
        pageCounter: Math.ceil(action.payload.count / 10),
        error: false,
      };
    case productType.FAILURE_FETCHED_PRODUCT:
      return {
        ...state,
        loading: false,
        product: null,
        error: true,
        errorMessage: action.errorMessage,
        pageCounter: 1,
      };
    case productType.CHANGE_GRADE_PARAMS:
      return {
        gradeParams: action.payload,
      };
    case productType.CHANGE_SUBJECT_PARAMS:
      return {
        subjectParams: action.payload,
      };
    case productType.CHANGE_PAGE_PARAMS:
      return {
        pageParams: action.payload,
      };

    default:
      return state;
  }
};

export default productReducer;
